import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useGetCustomerQuery } from 'services/customers'
import useGlobalLoader from 'utils/custom-hooks/useGlobalLoader'
import ContactGrid from './ContactGrid'
import { useCustomerHeader } from '../account/utils'

const CustomerContacts = () => {
  const { id: customerId } = useParams()
  const { data: customerData, isLoading } = useGetCustomerQuery({ customerId }, { skip: !customerId })
  const rows =
    customerData?.contacts?.map(con => {
      const name = `${con.firstName || ''} ${con.lastName || ''}`
      const locationName = customerData.locations?.find(loc => loc.id === con.locationId)?.name
      return {
        ...con,
        name,
        locationName,
      }
    }) || []

  useCustomerHeader(customerData)
  useGlobalLoader(isLoading)

  if (isLoading) return null

  return (
    <Box p={3} data-testid="customer-contacts">
      <Grid container rowSpacing={4}>
        <Grid item xs={12}>
          <Typography variant="h5">Contacts</Typography>
        </Grid>
        <Grid item xs={12}>
          <ContactGrid autoHeight rows={rows} customerData={customerData} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default CustomerContacts
